import React from "react";
import TopBarLayout from "../../pages/layout/TopBarLayout";
import SmsNotif from "../notifcation/SmsNotif";
// import CartButton from "../cart/CartButton";
import NavLinks from "./NavLinks";

const TopBar = () => {
    return (
        <TopBarLayout>
            <div className="flex flex-col items-center w-full px-2 space-y-0 pt-2">
                <div className="flex items-center px-1 justify-between w-full mb-1">
                    {/* Le wordmark en image flottait mal dans ce header : on
                        garde le texte, à ajuster quand un logo aux bonnes
                        mesures sera livré. */}
                    <span className="text-2xl font-extrabold tracking-tight leading-none select-none">
                        <span className="text-gray-900">Chine</span><span className="text-main-button">xpress</span>
                    </span>
                    <div className="flex items-center">
                        {/* <CartButton /> */}
                        <SmsNotif />
                    </div>
                </div>
                <NavLinks />
            </div>
        </TopBarLayout>
    );
}

export default TopBar;
